/**
 * Module contracts kya
 * @module app.kya.edition
 */
define([
    'angular',
    'modules/kya/edition/controllers/editionCtrl',
    'modules/kya/edition/factories/editionService',
    'modules/kya/edition/factories/editionProvider'
], function(angular) {


    angular.module('app.kya.edition', [
        'app.kya.edition.editionCtrl',
        'app.kya.edition.editionService',
        'app.kya.edition.editionProvider'
    ]);
});
